export const FORM_TEMPLATES = {
  contactFormApp: 'dd95e41e-ee00-4bdd-bc37-b1d7ca56330e',
  contactFormAppDesign: 'dd95e41e-ee00-4bdd-bc37-b1d7ca56330e',
  contactFormAppStudioDesign: '77c927f7-e811-4023-a40e-24f83a3fcea6',
  subscribeFormApp: '240c319f-08f5-438b-8782-623c2da2f4ac',
  subscribeFormAppDesign: '240c319f-08f5-438b-8782-623c2da2f4ac',
  orderFormApp: '3f62de45-12c4-418e-b33e-2add84140562',
  orderFormAppDesign: '3f62de45-12c4-418e-b33e-2add84140562',
  contact1: 'e67bc4ee-6bac-4974-b8a4-0130d8d2d0c5',
  contact3: 'b06e7fe8-5680-470f-9dd1-9c7398888978',
  contact4: '4c6df2f1-b8cb-4535-8a6b-03ff580b3abd',
  contact5: 'a27e9cba-6a49-4aa6-9962-025945eda282',
  contact6: '80bd8cb9-b868-463e-ba82-9fe5b7d90f52',
  contact7: '187ae954-1ce0-412c-19d5-8fd082ab4a71',
  contact8: '0c8c44c5-f360-4a6b-0ffd-add53f72459f',
  contact9: '405b1c6d-8870-43ee-402f-d7218bb2cada',
  order1: 'e9e0278f-f0d4-4b18-b6a6-13b7700ea209',
  order2: '8c246610-ae8f-4468-9a3c-1293e6196b44',
  registration1: '4c2fa7e6-09c5-4efd-9a6a-10f9c30ce417',
  registration2: '18a38c6d-f7d1-4c68-891d-df2d784e5cd2',
  registration5: '0031fd77-2f25-4b61-a9b2-a5148751581d',
  application1: '45a39351-cd3f-46a0-9151-347179abc69c',
  application2: 'ac7c771a-a9d7-486a-aa3b-cb2c4ca59256',
  application3: '819c330c-25c2-4fe0-969d-c39bd5a6f76f',
  application4: '77436880-4322-4a69-bf98-d5d97a80936f',
  request1: '8396de95-491c-4f39-9523-cd82df93b0c0',
  request2: '9c96546a-a395-4974-9e6b-184ec1bd67b9',
  waiver1: 'd0259ab0-e751-4faa-8d95-ac1e3f3fdd94',
  waiver2: '764440a5-ee38-4383-976c-14e2ece54349',
  waiver3: 'ba4f5b97-2374-4ef1-97c1-4ab91d29e326',
  waiver4: '62f525f6-97db-4bed-a096-170bc556e753',
  subscribe1: '3fc80642-e464-489a-9da2-83a0b1aee893',
  subscribe2: 'a906c6ba-a792-4948-b758-da11e267d915',
  subscribe5: '844ca151-13f3-4780-91c0-20a16b914110',
  subscribe6: '83ea6f5f-09eb-4c08-e744-9070287a9e48',
  subscribe7: 'bd7e8cb0-4654-4ff1-badb-452dc7a200cf',
  catering1: '1e01e218-b101-4754-b547-6ce9274055f8',
  catering2: '5a2c7fdd-ed2f-4d63-996c-7853cbdb85be',
  sectionContact1: 'aa9bc7a0-f5bd-47e0-1b1f-33651c282710',
  sectionContact2: 'bdf18c56-d943-4e71-fdaf-2a04120199a9',
  sectionContact4: 'a9882876-4244-4fcf-89ca-4512dbfc36d6',
  blogSlotSubscribe: '16e4b037-5f5f-487b-6df1-ee2d95cfbb43',
  stripContact2: '1b284e0a-066b-40c8-677d-879702fa8877',
  stripContact4: '2657a0c9-46f1-434c-f7c8-5d973fa85340',
  stripContact5: '3a7790ae-b012-4593-5238-9928679febcb',
  stripContact6: '9bdd0029-82d9-4b22-8d78-0df7f0175833',
  donation1: '4ee1afed-c696-459d-6e71-ec8ff7569fc9',
  donation2: '93b56a30-3926-4575-6055-084620650787',
  lightboxSubscribe1: '945b55b1-5d4b-4fff-7d32-cd083bcfb501',
  lightboxSubscribe2: 'c97abfcd-2a84-4aad-2946-d5cd47c5433f',
  lightboxSubscribe3: '3f505aec-a5ab-46bf-3bca-5a22eda7538f',
  lightboxPromote2: '4b2b90b5-ba03-4fd1-8357-f6ffc9911910',
  sitegenContact1: '401d99a8-1e49-4d56-1e4b-56cc02970408',
  feedback1: '0a5dc0c0-f599-455b-5ce4-f2bf6139cdd5',
  feedback2: '2121e5bb-70bd-47cf-472c-cf9b6b3163d0',
  feedback3: '214bbd3b-dfea-41dd-5769-b602a5ffc17b',
  feedback4: '9be04800-2cbf-46c7-b2d0-90190d893597',
  serviceInquiry1: 'b15e442c-659f-402a-191a-fcfc5a4cce45',
  serviceInquiry2: '894b9b56-9a24-42e0-5c05-d0c1ad2fefc9',
  appointment1: 'f1ce59da-88a1-4589-f015-c0cf3e2f1eb9',
  appointment2: '8ce65d50-7dc7-4c1b-4bd8-f40569643e7f',
  volunteerRegistration: '4996a05a-49d9-4d75-8452-97a4bd323d6d',
  fundraiserOrder: '4d37f7b9-567d-41b8-a34f-092d896c4d94',
  foodOrder: 'fe028473-9e16-49a4-a46a-a7e61f325138',
  healthWaiver: '8d68f0c9-bfca-4603-a559-b7e0e689b7b5',
  workshopRegistration: 'b02fbfc2-5e2e-400f-8bbd-69b4e7ca09ea',
  classRegistration: 'cc80480e-4059-41f2-b948-a14157f1d908',
  programRegistration: '70af3abd-0d23-49ce-bd70-fbe87fac6030',
  housingApplication: '345484e7-6cbe-428b-a3aa-85d028c61b6e',
  gatedContent: 'fa9f1ab1-7ab1-4f84-9903-a1d8c8101366',
  parentalConsent: 'b10faeec-23ad-4328-b2d9-1fb6953a79ef',
  supportCause: 'f16ed907-ff24-4536-9ff3-74e3dd6b7e5a',
  clientSatisfaction1: '260f6a6a-1200-4d89-8a23-94dddb53b17a',
  mailingList: '948794f8-c3c1-4ef5-9bd7-49786fbb3426',
  subscribeToNewsletter: '28208e11-713c-48e2-b6a6-46614190bb12',
  courseEvaluation: '99306153-d34a-4539-b0a3-e05e76758138',
  workOrder: 'fae8128e-055a-4ec9-86b8-7fca4f44a833',
  clientSatisfaction2: '260f6a6a-1200-4d89-8a23-94dddb53b17a',
  scheduleCall: '46fa2d37-3906-4f87-b521-b13da2d3f05d',
  jobApplication: 'c9a32048-542a-4784-bed9-ff910da1e1c3',
  supportRequest: '9757b8a0-4920-4530-b336-7c1d8118cdf8',
  freelancerApplication: 'f7ff734d-327f-43cd-a0f0-7a9888837bd1',
  datingApplication2: '6c9be8f0-91bb-4ba9-96a0-e82194efe675',
  suggestedDonation1: '16aa96de-2558-4b74-927c-90dc4b481463',
  generalLiability: 'e75950c0-6667-4780-bd1c-e5e722da9c84',
  productReview: 'b6262a10-4d6a-4a86-9398-a90d86228269',
  internshipApplication: 'c4763e24-cb29-4056-82c8-56f89da67dad',
  communityMembership: '2fe08ed2-daef-459d-b8ac-d0a6d7668a3a',
  requestCall: '00164eda-42c7-40ed-8e85-6bbfcbb3a7e6',
  chatExperience: 'a0416dc3-9c32-4899-9f53-be6441126689',
  datingApplication: 'e58c93d2-a4e3-4a07-bbe2-0f90ba5b49eb',
  eventSubscription: '6e061349-a9b3-4b25-91d9-b88ae5fe2c47',
  gymMembership: 'e4b752e1-0bbd-495d-8f60-ce66753306c3',
  newsletterSignup: '558cb4ba-408e-4e93-9355-c0bf1cfee299',
  getPricequote: '74c9edaa-cc93-4f58-aff9-7423966ffe94',
  photographyConsent: '07d588de-78b5-49c3-af92-74fe2ab60d26',
  eventRegistration: 'c8388b1c-dc26-4fdf-9113-3b1b02b77b65',
  eventUpdates: 'a5be6153-b597-41c7-8dd5-668dec7baa99',
  bookAppointment: '3cc4f02a-41af-4af6-8bc8-9344f26bb415',
  apparelOrder: '95b9cfcc-c86e-4f29-a614-8e6d5c9f3a3f',
  requestDemo: '2014082e-99e4-4b2e-8a02-a1b697eb2785',
  serviceInquiry1E3: 'c87b4dbf-f430-467c-2577-6789736116ff',
  serviceInquiry2E3: 'f438222f-d4ea-4ee5-2c98-77601e860b44',
  appointment1E3: 'dc9f43f0-100d-4f59-b7c6-da1b0a938aa2',
  appointment2E3: '26306ff3-4933-4634-1486-7c52d4f8a468',
};

export const FORM_TEMPLATE_NAMES = {
  [FORM_TEMPLATES.contactFormApp]: 'Contact us',
  [FORM_TEMPLATES.contactFormAppDesign]: 'Contact us',
  [FORM_TEMPLATES.contactFormAppStudioDesign]: 'Contact us',
  [FORM_TEMPLATES.subscribeFormApp]: 'Subscribe',
  [FORM_TEMPLATES.subscribeFormAppDesign]: 'Subscribe',
  [FORM_TEMPLATES.orderFormApp]: 'Order form',
  [FORM_TEMPLATES.orderFormAppDesign]: 'Order form',
  [FORM_TEMPLATES.contact1]: 'Contact Form',
  [FORM_TEMPLATES.contact3]: 'Contact Form',
  [FORM_TEMPLATES.contact4]: 'Contact Form',
  [FORM_TEMPLATES.contact5]: 'Contact Form',
  [FORM_TEMPLATES.contact6]: 'Contact us 6',
  [FORM_TEMPLATES.contact7]: 'Contact us 7',
  [FORM_TEMPLATES.contact8]: 'Contact us 8',
  [FORM_TEMPLATES.contact9]: 'Contact us 9',
  [FORM_TEMPLATES.order1]: 'Order Form',
  [FORM_TEMPLATES.order2]: 'Order Form',
  [FORM_TEMPLATES.registration1]: 'Registration Form',
  [FORM_TEMPLATES.registration2]: 'Registration Form',
  [FORM_TEMPLATES.registration5]: 'Registration Form',
  [FORM_TEMPLATES.application1]: 'Application Form',
  [FORM_TEMPLATES.application2]: 'Application Form',
  [FORM_TEMPLATES.application3]: 'Application Form',
  [FORM_TEMPLATES.application4]: 'Application Form',
  [FORM_TEMPLATES.request1]: 'Request Form',
  [FORM_TEMPLATES.request2]: 'Request Form',
  [FORM_TEMPLATES.waiver1]: 'Waiver Form',
  [FORM_TEMPLATES.waiver2]: 'Waiver Form',
  [FORM_TEMPLATES.waiver3]: 'Waiver Form',
  [FORM_TEMPLATES.waiver4]: 'Waiver Form',
  [FORM_TEMPLATES.subscribe1]: 'Subscribe Form',
  [FORM_TEMPLATES.subscribe2]: 'Subscribe Form',
  [FORM_TEMPLATES.subscribe5]: 'Subscribe Form',
  [FORM_TEMPLATES.subscribe6]: 'Subscribe 6',
  [FORM_TEMPLATES.subscribe7]: 'Subscribe 7',
  [FORM_TEMPLATES.catering1]: 'Catering Form',
  [FORM_TEMPLATES.catering2]: 'Catering Form',
  [FORM_TEMPLATES.sectionContact1]: 'Contact us',
  [FORM_TEMPLATES.sectionContact2]: 'Contact us',
  [FORM_TEMPLATES.sectionContact4]: 'Contact Form',
  [FORM_TEMPLATES.blogSlotSubscribe]: 'Subscribe',
  [FORM_TEMPLATES.stripContact2]: 'Contact Form',
  [FORM_TEMPLATES.stripContact4]: 'Contact Form',
  [FORM_TEMPLATES.stripContact5]: 'Contact Form',
  [FORM_TEMPLATES.stripContact6]: 'Contact Form',
  [FORM_TEMPLATES.donation1]: 'Donation Form',
  [FORM_TEMPLATES.donation2]: 'Donation Form',
  [FORM_TEMPLATES.lightboxSubscribe1]: 'Subscribe Form',
  [FORM_TEMPLATES.lightboxSubscribe2]: 'Subscribe Form',
  [FORM_TEMPLATES.lightboxSubscribe3]: 'Subscribe Form',
  [FORM_TEMPLATES.lightboxPromote2]: 'Promotion Form',
  [FORM_TEMPLATES.sitegenContact1]: 'Contact Form',
  [FORM_TEMPLATES.feedback1]: 'Feedback Form',
  [FORM_TEMPLATES.feedback2]: 'Feedback Form',
  [FORM_TEMPLATES.feedback3]: 'Feedback Form',
  [FORM_TEMPLATES.feedback4]: 'Feedback Form',
  [FORM_TEMPLATES.serviceInquiry1]: 'Service Inquiry',
  [FORM_TEMPLATES.serviceInquiry2]: 'Service Inquiry',
  [FORM_TEMPLATES.appointment1]: 'Schedule Appointment',
  [FORM_TEMPLATES.appointment2]: 'Schedule Appointment',
  [FORM_TEMPLATES.volunteerRegistration]: 'Volunteer registration form',
  [FORM_TEMPLATES.fundraiserOrder]: 'Fundraiser order form',
  [FORM_TEMPLATES.foodOrder]: 'Food order form',
  [FORM_TEMPLATES.healthWaiver]: 'Health declaration waiver',
  [FORM_TEMPLATES.workshopRegistration]: 'Workshop registration form',
  [FORM_TEMPLATES.classRegistration]: 'Class registration form',
  [FORM_TEMPLATES.programRegistration]: 'Program registration form',
  [FORM_TEMPLATES.housingApplication]: 'Housing application form',
  [FORM_TEMPLATES.gatedContent]: 'Gated content',
  [FORM_TEMPLATES.parentalConsent]: 'Parental consent',
  [FORM_TEMPLATES.supportCause]: 'Support a Cause Form',
  [FORM_TEMPLATES.clientSatisfaction1]: 'Client satisfaction',
  [FORM_TEMPLATES.mailingList]: 'Mailing list',
  [FORM_TEMPLATES.subscribeToNewsletter]: 'Subscribe to newsletter',
  [FORM_TEMPLATES.courseEvaluation]: 'Course evaluation',
  [FORM_TEMPLATES.workOrder]: 'Work order form',
  [FORM_TEMPLATES.clientSatisfaction2]: 'Client satisfaction',
  [FORM_TEMPLATES.scheduleCall]: 'Schedule a call',
  [FORM_TEMPLATES.jobApplication]: 'Job application form',
  [FORM_TEMPLATES.supportRequest]: 'IT support request',
  [FORM_TEMPLATES.freelancerApplication]: 'Freelancer application',
  [FORM_TEMPLATES.datingApplication2]: 'Dating application form 2',
  [FORM_TEMPLATES.suggestedDonation1]: 'Suggested Donations Amount 1',
  [FORM_TEMPLATES.generalLiability]: 'General liability',
  [FORM_TEMPLATES.productReview]: 'Product review',
  [FORM_TEMPLATES.internshipApplication]: 'Internship application form',
  [FORM_TEMPLATES.communityMembership]: 'Community membership form',
  [FORM_TEMPLATES.requestCall]: 'Request a call',
  [FORM_TEMPLATES.chatExperience]: 'Chat experience',
  [FORM_TEMPLATES.datingApplication]: 'Dating application form',
  [FORM_TEMPLATES.eventSubscription]: 'Event subscription',
  [FORM_TEMPLATES.gymMembership]: 'Gym membership form',
  [FORM_TEMPLATES.newsletterSignup]: 'Newsletter signup',
  [FORM_TEMPLATES.getPricequote]: 'Get a price quote',
  [FORM_TEMPLATES.photographyConsent]: 'Photography consent form',
  [FORM_TEMPLATES.eventRegistration]: 'Event registration form',
  [FORM_TEMPLATES.eventUpdates]: 'Event updates',
  [FORM_TEMPLATES.bookAppointment]: 'Book an Appointment',
  [FORM_TEMPLATES.apparelOrder]: 'Apparel Order Form',
  [FORM_TEMPLATES.requestDemo]: 'Request a demo',
  [FORM_TEMPLATES.serviceInquiry1E3]: 'Service Inquiry',
  [FORM_TEMPLATES.serviceInquiry2E3]: 'Service Inquiry',
  [FORM_TEMPLATES.appointment1E3]: 'Schedule Appointment',
  [FORM_TEMPLATES.appointment2E3]: 'Schedule Appointment',
};

export enum FormAppPreset {
  Blank = 'blankFormApp',
  Existing = 'existingFormApp',
}

export type PresetId =
  | FormAppPreset.Blank
  | FormAppPreset.Existing
  | PresetWithTemplate;

export type PresetWithTemplate = keyof typeof FORM_TEMPLATES;

export const isPresetId = (value: unknown): value is PresetId => {
  if (typeof value !== 'string') {
    return false;
  }
  return (
    value === FormAppPreset.Blank ||
    value === FormAppPreset.Existing ||
    Object.keys(FORM_TEMPLATES).includes(value)
  );
};

export const isPresetWithTemplate = (
  presetId: PresetId | string,
): presetId is PresetWithTemplate =>
  Object.keys(FORM_TEMPLATES).includes(presetId);

export const presetIdToTemplateId = (presetId: PresetId): string | undefined =>
  presetId === FormAppPreset.Blank || presetId === FormAppPreset.Existing
    ? undefined
    : FORM_TEMPLATES[presetId];

export const templateIdToPresetId = (
  templateId: string,
): PresetWithTemplate | undefined => {
  const entry = Object.entries(FORM_TEMPLATES).find(
    ([_, id]) => id === templateId,
  );
  return entry ? (entry[0] as PresetWithTemplate) : undefined;
};

export const isTemplateId = (formId: string) =>
  Object.values(FORM_TEMPLATES).includes(formId);

export function isEcomRequiredTemplate(presetId: string) {
  return [
    'orderFormApp',
    'orderFormAppDesign',
    'fundraiserOrder',
    'foodOrder',
    'supportCause',
    'workOrder',
    'suggestedDonation1',
    'apparelOrder',
  ].includes(presetId);
}

export function isServicesRequiredForPreset(presetId: PresetWithTemplate) {
  return isServicesRequiredForTemplateId(FORM_TEMPLATES[presetId]);
}

export function isServicesRequiredForTemplateId(templateId: string) {
  return [
    FORM_TEMPLATES.serviceInquiry1,
    FORM_TEMPLATES.serviceInquiry2,
    FORM_TEMPLATES.serviceInquiry1E3,
    FORM_TEMPLATES.serviceInquiry2E3,
  ].includes(templateId);
}

export function isSchedulingRequiredForPreset(presetId: PresetWithTemplate) {
  return isSchedulingRequiredForTemplateId(FORM_TEMPLATES[presetId]);
}

export function isSchedulingRequiredForTemplateId(templateId: string) {
  return [
    FORM_TEMPLATES.appointment1,
    FORM_TEMPLATES.appointment2,
    FORM_TEMPLATES.serviceInquiry2,
    FORM_TEMPLATES.bookAppointment,
    FORM_TEMPLATES.appointment1E3,
    FORM_TEMPLATES.appointment2E3,
    FORM_TEMPLATES.serviceInquiry2E3,
  ].includes(templateId);
}
